import { render } from "./Treatment_Process_Guide.vue?vue&type=template&id=7a4f605c"
import script from "./Treatment_Process_Guide.vue?vue&type=script&lang=js"
export * from "./Treatment_Process_Guide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__